import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Fragment } from 'react';
import { MenuWrapper } from './BKJMenu.styled.js';
export const BKJMenu = forwardRef(({ isMenuOpen, closeMenu, children, className, ...props }, ref) => {
    const buildChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            const props = {
                onClick: () => {
                    child?.props?.onClick && child.props.onClick();
                    closeMenu();
                },
            };
            return React.cloneElement(child, props);
        }
        return null;
    });
    return (_jsx(Fragment, { children: isMenuOpen && children && (_jsx(MenuWrapper, { ref: ref, className: className, ...props, children: buildChildren })) }));
});
//# sourceMappingURL=BKJMenu.js.map